import { setupFormState } from '@/components/form/tidal-form'
import { DriverFormValues } from './types'

export const emptyDriverId = ''

export const defaultInitialValues: DriverFormValues = {
  id: emptyDriverId,
  name: '',
  email: '',
  'new-password': '',
  gpsDeviceId: null,
  summarizeFutureMobileRoute: false,
  mobileFutureDaysVisibility: '2',
  trackDriver: false,
  barcodeAttachmentAllowed: false,
}

export const form = setupFormState<DriverFormValues>({
  id: 'driverForm',
  initialValues: defaultInitialValues,
})
